import React from 'react';
import PropTypes from 'prop-types';

import { HEATMAP_DAYS } from 'constants/heatmap';

import Message from 'components/Message';

import { DAY_HEADER_MESSAGES } from './messages';

export const renderDefaultDayHeaders = () =>
  DAY_HEADER_MESSAGES.map(message => <Message key={message.id} message={message} />);

export function DayHourHeatmapTableHead({ dayHeaders }) {
  const headers = dayHeaders ?? renderDefaultDayHeaders();

  return (
    <thead>
      <tr>
        <th scope="col" />
        {headers.map((header, index) => (
          <th key={HEATMAP_DAYS[index]} scope="col">
            {header}
          </th>
        ))}
      </tr>
    </thead>
  );
}

DayHourHeatmapTableHead.propTypes = {
  dayHeaders: PropTypes.arrayOf(PropTypes.node),
};
